/**
 * v-img-fallback directive
 * 圖片載入失敗時，把 src 換成指定的 fallback URL（只換一次，避免迴圈）。
 * 集中處理圖片 fallback，取代各元件各自寫的 @error handler。
 *
 * 使用方式：
 * img(:src="cover", v-img-fallback="fallbackUrl")
 */
const imgFallbackClient = {
  // SSR support: error 只在瀏覽器觸發，此指令僅在 client 生效
  getSSRProps() {
    return {}
  },

  mounted(el, binding) {
    el._imgFallbackHandler = () => {
      // 已經是 fallback 就不再換，避免無限迴圈；src 變更（清單重用）時會自然重試
      if (binding.value && el.getAttribute('src') !== binding.value) {
        el.src = binding.value
      }
    }
    el.addEventListener('error', el._imgFallbackHandler)
    // 指令掛上前圖片就已載入失敗的情況
    if (el.complete && el.naturalWidth === 0) {
      el._imgFallbackHandler()
    }
  },

  unmounted(el) {
    if (el._imgFallbackHandler) {
      el.removeEventListener('error', el._imgFallbackHandler)
      delete el._imgFallbackHandler
    }
  },
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('img-fallback', imgFallbackClient)
})
